
<search
  ref="search"
  global
  header
  :source="globalSearchSource"
  :sort="sort"
  :placeholder="placeholder"
  v-bind="$attrs"
  @select="handleSelect"
  @enter="enterSearch"
>
  <template #header>
    <div class="pills-header">
      <pill
        v-for="(option, i) in sourceOptions"
        :key="i"
        :active="option.value === globalSearchSource"
        @click="globalSearchSource = option.value; focus()"
      >
        <icon :name="option.icon" />
        <span class="pill-text">{{ option.label }}</span>
      </pill>
    </div>
  </template>

  <template #default="slotProps">
    <profile-list-item
      v-if="slotProps.source === 'profiles'"
      :profile="slotProps.item"
    />

    <card-list-item
      v-if="slotProps.source === 'cards'"
      split
      :card="slotProps.item"
      :fields="['pop', 'marketValue', 'currentValue']"
    >
      <verified-icon />
    </card-list-item>

    <shop-list-item
      v-else-if="slotProps.source === 'listings'"
      split
      :item="slotProps.item"
    />

    <sales-list-item
      v-else-if="slotProps.source === 'salesarchive'"
      split
      :item="slotProps.item"
    >
      <verified-icon v-if="slotProps.item.cardId" />
    </sales-list-item>

    <index-list-item
      v-else-if="slotProps.source === 'players'"
      split
      :index="slotProps.item"
      :fields="['totalCards', 'dailySales', 'monthlyPercentChange']"
    />
  </template>
</search>
